module.exports = __webpack_public_path__ + "static/media/pesce.52089601.svg";